var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCircleTimes = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 13,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 0A6.5 6.5 0 1 0 13 6.5 6.508 6.508 0 0 0 6.5 0Z",
  fill: "red",
  fillOpacity: 0.45
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 3.936,
  width: 1.323,
  height: 8.576,
  rx: 0.662,
  transform: "rotate(-45 3 3.936)",
  fill: "#fff"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 9.064,
  y: 3,
  width: 1.323,
  height: 8.576,
  rx: 0.662,
  transform: "rotate(45 9.064 3)",
  fill: "#fff"
})));
export { SvgCircleTimes as ReactComponent };
export default __webpack_public_path__ + "a24e30a305f9fb5cedcd67a314887a58.svg";